import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TableLoaderComponent} from "./table-loader.component";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {SharedModule} from "primeng/api";
import {SkeletonModule} from "primeng/skeleton";
import {TableModule} from "primeng/table";
import {TooltipModule} from "primeng/tooltip";


@NgModule({
  declarations: [TableLoaderComponent],
  exports: [TableLoaderComponent],
  imports: [CommonModule, ButtonModule, RippleModule, SharedModule, SkeletonModule, TableModule, TooltipModule]
})
export class TableLoaderModule { }
